import axios from "axios"
import getApiUrl from '../../config';

export const getManagersList = (adminId) =>
     async dispatch => {
        try{
        const managerList = []
        //axios call
        const config = {
            headers: {
                'Custom-Header': 'value',
                'Content-Type': 'application/json'
            }
        };
       const res =  await axios.post(getApiUrl('newAdminDashboard'),config)
        //change to final format
        

        //dispatch the state
        if(true){
            dispatch({type:"MANAGERS_LIST_SUCCESS",data:{managersList:[...res.data.body]}})
        }
        else{
            dispatch({type:"MANAGERS_LIST_FAILED",err: "ERROR MESSAGE"})
        }
    }
    catch(error){
        console.log(error)
    }
        
    }
